import { httpClient } from "../../shared/configs/http-client"

type AskAiPayload = {
    threadId?: string,
    experiment: {
      title: string,
      description: string,
      unitOfMeasurement: string,
      data: Array<{
        second: number,
        value: number,
      }>
    },
    messages: Array<{
      isAi: boolean,
      message: string,
    }>
  }
  
  type AskAiResponse = {
    response: string;
    threadId: string;
  }
  
  export const askAi = async (payload: AskAiPayload) => {
    const { data } = await httpClient.post<AskAiResponse>(`/public/sensors/ask-ai`, payload)
  
    return data
  }